export default __webpack_public_path__ + "locales/en/Settings.json?hash=4eb9735d51c4151db9e36072e0d304f4";